<app-add-commentaire [allowed_to_update]="true" [fromType]="'T'">
</app-add-commentaire>
